import { callAppFunc } from './jsbridge/index';

const IN_APP = process.env.GATSBY_INAPP === 'true';

let isShowing = false;

const showLoading = (immediate = true) => {
  if (IN_APP && !isShowing) {
    isShowing = true;
    callAppFunc('showLoading', { immediate: immediate ? 'true' : 'false' });
  }
};

const dismissLoading = (immediate = true) => {
  console.log('INAPP', IN_APP);
  if (IN_APP) {
    callAppFunc('dismissLoading', { immediate: immediate ? 'true' : 'false' });
  }

  isShowing = false;
};

export { showLoading, dismissLoading };
